import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { BookingForm } from "@/components/BookingForm";
import { Gallery } from "@/components/Gallery";
import { Reviews } from "@/components/Reviews";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { BookingPopup } from "@/components/BookingPopup";

function App() {
  return (
    <div className="App" data-testid="app-container">
      <Header />
      <main>
        <Hero />
        <Services />
        <BookingForm />
        <Gallery />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <BookingPopup />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
